import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Mechanical.bc65a33d",
  "use": "Mechanical.bc65a33d-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Mechanical.bc65a33d\">\n  <path d=\"M7 4v2h3v2H7l-2 2v3H4v-3H2v8h2v-3h1v3h3l2 2h8v-4h1v3h3V9h-3v3h-1V8h-6V6h3V4H7z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol